import React from 'react';

/**
 * Reusable labeled number input. Renders nicely on dark theme.
 */
export const NumberField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  min,
  max,
  step = 'any',
  suffix,
  error,
  testId,
  required = false
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-slate-300 mb-1.5">
        {label}{required && <span className="text-rose-400 ml-0.5">*</span>}
      </label>
      <div className="relative">
        <input
          id={id}
          type="number"
          inputMode="decimal"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={testId}
          className={`w-full bg-slate-800/70 border ${error ? 'border-rose-500' : 'border-slate-700'} focus:border-blue-500 focus:outline-none rounded-xl px-4 py-2.5 ${suffix ? 'pr-14' : ''} text-white text-sm placeholder:text-slate-500 transition-colors`}
        />
        {suffix && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-xs font-medium pointer-events-none">{suffix}</span>
        )}
      </div>
      {error && <p className="text-rose-400 text-xs mt-1">{error}</p>}
    </div>
  );
};

/**
 * Reusable select.
 */
export const SelectField = ({ id, label, value, onChange, options, testId, required = false }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-slate-300 mb-1.5">
      {label}{required && <span className="text-rose-400 ml-0.5">*</span>}
    </label>
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
      className="w-full bg-slate-800/70 border border-slate-700 focus:border-blue-500 focus:outline-none rounded-xl px-4 py-2.5 text-white text-sm transition-colors"
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

/**
 * Gender radio group.
 */
export const GenderField = ({ value, onChange, testIdPrefix = 'gender' }) => (
  <div>
    <span className="block text-sm font-medium text-slate-300 mb-1.5">Gender</span>
    <div className="grid grid-cols-2 gap-2">
      {[
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' }
      ].map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          data-testid={`${testIdPrefix}-${opt.value}`}
          aria-pressed={value === opt.value}
          className={`px-4 py-2.5 rounded-xl text-sm font-medium border transition-all ${
            value === opt.value
              ? 'bg-gradient-to-r from-blue-600 to-cyan-600 border-blue-500 text-white shadow shadow-blue-500/20'
              : 'bg-slate-800/50 border-slate-700 text-slate-400 hover:text-white hover:border-slate-600'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  </div>
);
